import type { Social_Media_Posts } from "@/src/gql/graphql";
import { SOCIAL_MEDIA_POSTS_CONFIG } from "@/features/social-media-posts/components/EnhancedSocialMediaPostsConfig";
import { SOCIAL_MEDIA_POST_DETAIL_CONFIG } from "@/features/social-media-posts/components/SocialMediaPostDetailConfig";
import { useSocialPostsConfigEnhancer } from "@/lib/hooks/api/shared/config-enhancers";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// SOCIAL MEDIA POSTS ENTITY DEFINITION
// ============================================================================
// First-class Hub entity modeled on `contracts`. Posts are usually authored by
// the marketing pipeline (see MARKETING_BRANDS rule), but the CRM also supports
// creating one by hand via the generic create form (see social-media-posts-graphql.ts).
// Column change: edit features/social-media-posts/components/EnhancedSocialMediaPostsConfig.ts.
// Detail change: edit features/social-media-posts/components/SocialMediaPostDetailConfig.ts.
// ============================================================================

export const socialMediaPostsEntity = defineEntity<Social_Media_Posts>({
  tableConfig: SOCIAL_MEDIA_POSTS_CONFIG,
  detailConfig: SOCIAL_MEDIA_POST_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },

  // Brands are database rows, so the `brand` field's options are injected at
  // render time from the registry — a brand onboarded under Marketing > Brands
  // appears in the filter, badge and inline editor with no deploy.
  useConfigEnhancer: (config) => useSocialPostsConfigEnhancer({ config }),
});
